module.exports = __webpack_public_path__ + "img/ic-groupby.fff5d38c.svg";